import { Listbox } from "@headlessui/react";
import { mdiChevronDown } from "@mdi/js";
import Icon from "@mdi/react";
import clsx from "clsx";
import Checkbox from "components/Checkbox";

import { getClassByVariant } from "helpers/getClassByVariant";
import type { IOption } from "models/Form";
import styles from "./style.module.scss";

interface IProps {
  value: Array<IOption>;
  onChange: (value: Array<IOption>) => void;
  options: Array<IOption>;
  label?: string;
  className?: string;
  btnClass?: string;
  arrowClass?: string;
  color?: "primary" | "secondary";
  direction?: "up" | "down";
  placeholder?: string;
  disabled?: boolean;
}

export default function MultiSelect({
  options,
  value = [],
  onChange,
  label,
  className,
  color = "primary",
  btnClass,
  arrowClass,
  direction = "down",
  placeholder,
  disabled
}: Readonly<IProps>) {
  const isItemSelected = (selectedValue: string) => {
    return value.map((item) => item.value).includes(selectedValue);
  };

  return (
    <div className={clsx(styles.multiSelectContainer, className)}>
      {label && (
        <label className={clsx(styles.selectLabel, getClassByVariant(color)?.label)}>{label}</label>
      )}

      <Listbox
        value={value}
        onChange={onChange}
        as="div"
        multiple
        className={styles.selectWrapper}
        disabled={disabled}>
        <Listbox.Button
          className={clsx(styles.selectButton, getClassByVariant(color)?.input, btnClass, {
            "cursor-not-allowed bg-input/50": disabled,
            "!text-placeholder": value.length === 0
          })}>
          <div className={styles.selectedOptions}>
            {value.length
              ? value.map((item) => <span key={item.id}>{item.label}</span>)
              : placeholder}
          </div>
          <Icon path={mdiChevronDown} className={clsx(styles.selectArrow, arrowClass)} />
        </Listbox.Button>

        <Listbox.Options
          className={clsx(styles.selectList, direction === "up" && "!top-auto !bottom-full")}>
          {options.map((item) => (
            <Listbox.Option key={item.value} value={item} className={clsx(styles.selectItem)}>
              <div className="pointer-events-none">
                <Checkbox
                  checked={isItemSelected(item.value)}
                  checkBoxClass="!w-4 !h-4 !border-text"
                  onChange={() => {}}>
                  {item.label}
                </Checkbox>
              </div>
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </Listbox>
    </div>
  );
}
